module.exports = __webpack_public_path__ + "img/stop-icon.57279911.svg";